import script from "./MapWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./MapWidget.vue?vue&type=script&setup=true&lang=js"

import "./MapWidget.vue?vue&type=style&index=0&id=47794af0&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47794af0"]])

export default __exports__